// Maps a homework section to a vibrant, distinct subject colour theme.
const THEMES = {
  writing: {
    key: "writing", name: "Writing", hex: "#F97316", softHex: "#FFF7ED",
    bar: "bg-orange-500", soft: "bg-orange-50", border: "border-orange-200",
    heading: "text-orange-950", badge: "bg-orange-100 text-orange-800", icon: "text-orange-600",
    chipHover: "hover:border-orange-300", dot: "bg-orange-500",
  },
  maths: {
    key: "maths", name: "Mathematics", hex: "#0EA5E9", softHex: "#F0F9FF",
    bar: "bg-sky-500", soft: "bg-sky-50", border: "border-sky-200",
    heading: "text-sky-950", badge: "bg-sky-100 text-sky-800", icon: "text-sky-600",
    chipHover: "hover:border-sky-300", dot: "bg-sky-500",
  },
  science: {
    key: "science", name: "Science", hex: "#10B981", softHex: "#ECFDF5",
    bar: "bg-emerald-500", soft: "bg-emerald-50", border: "border-emerald-200",
    heading: "text-emerald-950", badge: "bg-emerald-100 text-emerald-800", icon: "text-emerald-600",
    chipHover: "hover:border-emerald-300", dot: "bg-emerald-500",
  },
  english: {
    key: "english", name: "English & Reading", hex: "#6366F1", softHex: "#EEF2FF",
    bar: "bg-indigo-500", soft: "bg-indigo-50", border: "border-indigo-200",
    heading: "text-indigo-950", badge: "bg-indigo-100 text-indigo-800", icon: "text-indigo-600",
    chipHover: "hover:border-indigo-300", dot: "bg-indigo-500",
  },
  general: {
    key: "general", name: "General", hex: "#8B5CF6", softHex: "#F5F3FF",
    bar: "bg-violet-500", soft: "bg-violet-50", border: "border-violet-200",
    heading: "text-violet-950", badge: "bg-violet-100 text-violet-800", icon: "text-violet-600",
    chipHover: "hover:border-violet-300", dot: "bg-violet-500",
  },
};

export function subjectTheme(section = "", name = "") {
  const s = `${section} ${name}`.toLowerCase();
  if (s.includes("writ")) return THEMES.writing;
  if (s.includes("math") || s.includes("numeric") || s.includes("quantit")) return THEMES.maths;
  if (s.includes("scien")) return THEMES.science;
  if (s.includes("read") || s.includes("english") || s.includes("verbal") || s.includes("comprehen")) return THEMES.english;
  return THEMES.general;
}

export default subjectTheme;
